import React, { useState, useEffect } from "react";
import moment from "moment";
import { Box, useMediaQuery } from "@mui/material";
import SquareIcon from "@mui/icons-material/Square";

export default function CountDownTimer({ time }) {
  const matches = useMediaQuery("(max-width:700px)");

  const [countTime, setCountDateTime] = useState({
    time_days: 0,
    time_Hours: 0,
    time_Minusts: 0,
    time_seconds: 0,
  });
  const startTime = async () => {
    let until = moment.unix(time).format("x");
    let interval = setInterval(() => {
      let now = moment().format("x");
      const distance = +until - +now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minuts = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setCountDateTime({
          ...countTime,
          time_days: days,
          time_Hours: hours,
          time_Minusts: minuts,
          time_seconds: seconds,
        });
      }
    }, 1000);
  };
  useEffect(() => {
    startTime();
  }, [time]);

  const timerStyle = {
    backgroundColor: "#F7F7F7",
    borderRadius: "10px",
    boxShadow: "0px 14.171783447265625px 38.97240447998047px 0px #000000CC",
    color: "#121212",
    fontSize: matches ? "30px" : "48px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: matches ? "60px" : "85px",
    width: matches ? "55px" : "85px",
    letterSpacing: 3,
    fontFamily: "Saira Semi Condensed",
    fontWeight: "700",
    pl: matches ? 0.5 : 0.7,
  };

  const timerValueStyle = {
    color: "#ffffff",
    fontFamily: "Saira Semi Condensed",
    fontSize: matches ? "17px" : "26px",
    fontWeight: "600",
    marginTop: "10px",
    mt: 2,
  };
  const squareBoxStyle = {
    mx: { xs: 0.8, sm: 1.5, md: 1.5 },
    mb: matches ? 5.5 : 9,
    color: "#F7F7F7",
    fontWeight: "700",
    fontSize: matches ? "20px" : "30px",
  };
  return (
    <>
      <Box
        mt={{ xs: 2, sm: 2 }}
        display="flex"
        alignItems="center"
        justifyContent={{ xs: "center", md: "start" }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box sx={timerStyle}>
            {countTime.time_days > 9 ? "" : 0}
            {countTime.time_days}
          </Box>
          <Box sx={timerValueStyle}>Day</Box>
        </Box>
        <Box sx={squareBoxStyle}>
          <SquareIcon sx={{ fontSize: matches ? "8px" : "10px" }} />

          <SquareIcon
            sx={{
              fontSize: matches ? "8px" : "10px",
              marginTop: matches ? "10px" : "20px",
              display: "block",
            }}
          />
        </Box>

        <Box display="flex" flexDirection="column" alignItems="center">
          <Box sx={timerStyle}>
            {countTime.time_Hours > 9 ? "" : 0}
            {countTime.time_Hours}
          </Box>
          <Box sx={timerValueStyle}>Hours</Box>
        </Box>
        <Box sx={squareBoxStyle}>
          <SquareIcon sx={{ fontSize: matches ? "8px" : "10px" }} />

          <SquareIcon
            sx={{
              fontSize: matches ? "8px" : "10px",
              marginTop: matches ? "10px" : "20px",
              display: "block",
            }}
          />
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box sx={timerStyle}>
            {countTime.time_Minusts > 9 ? "" : 0}
            {countTime.time_Minusts}
          </Box>
          <Box sx={timerValueStyle}>Mins</Box>
        </Box>
        <Box sx={squareBoxStyle}>
          <SquareIcon sx={{ fontSize: matches ? "8px" : "10px" }} />
          <SquareIcon
            sx={{
              fontSize: matches ? "8px" : "10px",
              marginTop: matches ? "10px" : "20px",
              display: "block",
            }}
          />
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box sx={timerStyle}>
            {countTime.time_seconds > 9 ? "" : 0}
            {countTime.time_seconds}
          </Box>
          <Box sx={timerValueStyle}>Sec</Box>
        </Box>
      </Box>
    </>
  );
}
